import React from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import ProductDetailCard from '~/components/productDetailCard/productDetailCard';
import ProductIngredientsCard from '~/components/productIngredientsCard/productIngredientsCard';
import ProductSummaryCard from '~/components/productSummaryCard/productSummaryCard';
import ProductCurrentLotsCard from '~/containers/productLotsCard/current';
import ProductPendingLotsCard from '~/containers/productLotsCard/pending';
import ProductCompletedLotsCard from '~/containers/productLotsCard/completed';
import ProductVariantsCard from '~/components/productVariantsCard/productVariantsCard';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getProductQuery = gql`
  query product($id: Int!) {
    product(id: $id) {
      id
      name
      customsName
      description
      abv
      volume
      lotPrefix
      costPerLitre
      beerStyle {
        id
        name
      }
      ingredients {
        id
        amount
        measurementType
        ingredient {
          name
          type
        }
      }
      variants {
        id
        name
        packagingCost
        taxPerLitre
        vesselType {
          id
          quantity
          volume
        }
      }
      hsCode {
        id
        name
      }
      mostRecentLot {
        id
        completedAt
        volume
      }
      lastThirtyDaysBrewingVolume
      currentYearsBrewingVolume
    }
  }
`;

const Product = ({ onCompleted, id }) => (
  <Query query={getProductQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { product } = data;
      return (
        <div className="flex content">
          <div className="flex-2 mr4">
            <ProductDetailCard className="mb4" {...product} />
            <ProductIngredientsCard className="mb4" ingredients={product.ingredients} />
            <ProductVariantsCard className="mb4" variants={product.variants} />
            <ProductPendingLotsCard className="mb4" id={id} />
            <ProductCurrentLotsCard className="mb4" id={id} />
            <ProductCompletedLotsCard id={id} />
          </div>
          <div className="flex-1">
            <ProductSummaryCard className="mb4" product={product} />
          </div>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(Product);



// WEBPACK FOOTER //
// ./src/containers/product/product.jsx